import { Typography } from 'design-system/src/components/Typography/Typography';
import { formatStandardDate } from 'shared-utils/utils/formatDate';
import type { TaskEvent } from '../../../api';

const bannerClassName = 'mb-4 rounded-medium bg-surface-200 p-3';

/**
 * Banner shown on completed tasks indicating when and by whom the task was completed.
 */
const TaskCompletionEventBanner: React.FC<{ completionEvent?: TaskEvent }> = ({ completionEvent }) => {
  if (!completionEvent) {
    return (
      <div className={bannerClassName}>
        <Typography>This task was closed.</Typography>
      </div>
    );
  }

  return (
    <div className={bannerClassName}>
      <Typography>
        This task was completed on{' '}
        <Typography weight="bold" renderedAs="span">
          {formatStandardDate(completionEvent.event_timestamp)}
        </Typography>
        {completionEvent.user && (
          <>
            {' '}
            by{' '}
            <Typography weight="bold" renderedAs="span">
              {completionEvent.user}
            </Typography>
          </>
        )}
        {completionEvent.label ? ':' : '.'}
      </Typography>
      {completionEvent.label && (
        <Typography className="mt-2">
          {completionEvent.label}
        </Typography>
      )}
    </div>
  );
};

export default TaskCompletionEventBanner;
